// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"632":"93dedeb3","662":"6b75a338"}[chunkId] + ".css";
};